@import '../../../globals/main.scss';
$spacing: 1.6rem;

.pn-chat {
  @media (max-width: 768px) {
    &:not(.minimized) {
      position: absolute;
      height: 100dvh;
      width: 100dvw;
      max-width: 100%;
      top: 0;
      left: 0;
    }

    &.minimized {
      height: 70px;
      border-radius: 0.8rem 0.8rem 0 0;
    }
  }

  @media (min-width: 768px) and (max-width: 1024px) {
    max-width: 350px;
  }

  display: flex;
  flex-direction: column;
  height: 600px;
  width: 400px;
  max-width: 400px;
  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.25), 0 -2px 4px 0 rgba(240, 240, 240, 0.55);
  border-radius: 1.6rem;

  .chat-header {
    background-color: $white;
    padding: 0.8rem;
    padding-left: 1.6rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid $gray50;

    @media (min-width: 768px) {
      border-radius: 1.6rem 1.6rem 0 0;
    }

    .chat-controls {
      display: flex;
    }

    pn-button.minimize-btn {
      button.pn-button {
        padding-bottom: 0;
        margin-right: 1rem;

        .pn-button-content {
          align-items: flex-end;
          position: absolute;
          bottom: 0px;
        }
      }
    }
  }

  .chat-header #chat-title {
    margin: 0;
    font-size: 1.6rem;
    font-weight: 500;
    line-height: 1;
    height: 100%;
    align-content: center;
  }

  .chat-main {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    overflow-y: auto;
    gap: $spacing;
    padding: $spacing;
    padding-bottom: $spacing * 2;
    background-color: $white;

    &.loading-chat-main {
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }

  .chat-loading-spinner {
    background-color: $blue700;
    width: 4.8rem;
    height: 4.8rem;
    border-radius: 4.8rem;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .chat-loading-content {
    color: $gray900;
    font-size: 1.6rem;
    font-weight: 400;
  }

  .chat-overview {
    text-align: center;
  }

  .chat-messages {
    display: flex;
    flex-direction: column;
    gap: $spacing;
    text-align: center;
  }

  .card-container {
    .slider-wrapper {
      margin: 0;
    }

    $card-gap: 1rem;

    .slides-container {
      display: flex;
      gap: $card-gap;
    }

    .slide:nth-child(even) [data-card] {
      width: calc(100% - $card-gap);
    }
  }

  @keyframes pulse {

    0%,
    100% {
      opacity: 1;
      transform: scale(1);
    }

    50% {
      opacity: 0.5;
      transform: scale(0.95);
    }
  }

  .chat-footer {
    background: $white;
    border-top: 1px solid $gray50;
    border-radius: 0 0 1.6rem 1.6rem;
  }

  .chat-footer .form {
    display: flex;
    gap: 0.7rem;
    padding: 1rem;
  }

  .chat-input-container {
    display: flex;
    flex-grow: 1;
    justify-content: space-between;
    gap: 0.7rem;
    background: $gray25;
    border-radius: 6.4rem;

    .chat-text-input {
      border: none;
      background: transparent;
      width: 100%;
      outline: 0.2rem solid transparent;
      outline-offset: 0.2rem;
      padding-left: 1.6rem;

      &:focus {
        border-radius: 6.4rem;
      }

      &:focus-visible {
        outline-color: $blue700;
      }

      &::placeholder {
        top: 2px;
        position: relative;
        color: $gray400;
      }
    }

    .chat-disabled-button {
      display: flex;
      width: 3.5em;
      min-height: 3em;
      min-width: 0;
      align-items: center;
      justify-content: center;
    }
  }

  &.minimized {
    background: transparent;
    border: initial;
    box-shadow: initial;
    max-width: 50px;
    max-height: 50px;
    min-width: initial;
    min-height: initial;
    transform: scale(0.95);

    cursor: pointer;

    .minimize-btn,
    .close-btn {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;

      button {
        display: none;
      }
    }

    .chat-main,
    .chat-footer {
      display: none;
    }
  }

  &.closed {
    display: none;
  }

  .open-chat-btn {
    .pn-button {
      width: 5.6rem;
      height: 5.6rem;
    }

    .pn-icon svg {
      width: 3.2rem;
      height: 3.2rem;
    }
  }

  .indicator-icon {
    padding: 0.2rem 0.8rem;
    margin-right: auto;
    margin-top: 1rem;
    margin-bottom: 2rem;
    visibility: hidden;
  }

  .minimize-btn,
  .close-btn {
    .pn-button pn-icon .pn-icon-svg path {
      fill: $blue700;
    }
  }
}

body.chat-open {
  @media (max-width: 768px) {
    overflow: hidden;
  }
}